<nav
  class="side-navigation"
  [attr.aria-label]="'Aria.Main-Navigation' | translate"
  [ngClass]="{
    'collapsed': isCollapsed,
    'rtl': currentLanguage === 'ar'
  }"
  #menuWrapper>
  @if (!isCollapsed) {
  <div class="nav-brand-row">
    <img
      src="assets/images/Hema_NoSlogan_NoBG.png"
      alt="Hema"
      class="nav-brand-logo" />
    <span class="nav-brand-divider" aria-hidden="true"></span>
    <span class="nav-brand-word" aria-hidden="true">HEMA GRC</span>
  </div>
  }
  <mat-accordion class="navbar-accordion" multi>
    @for (item of menuItems; track item.name) { @if(item.isShown){

    <div class="menu-item-wrapper">
      <ng-container
        [ngTemplateOutlet]="menuItemTemplate"
        [ngTemplateOutletContext]="{ item: item, level: MenuLevel.Root }">
      </ng-container>
    </div>
    } }
  </mat-accordion>
</nav>

<!-- Recursive Menu Item Template -->
<ng-template #menuItemTemplate let-item="item" let-level="level">
  <!-- Simple menu item without children - Expanded mode OR children in hover dropdown -->
  @if (!item.children || item.children.length === 0) { @if (!isCollapsed ||
  (isCollapsed && level > MenuLevel.Root)) { @if(item.isShown){
  <a
    class="menu-link simple-link"
    [class.child-link]="level > MenuLevel.Root"
    [class.padding-child]="item.children?.length === 0"
    [style.paddingInlineStart.px]="16 + level * 14"
    [routerLink]="item.url"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: false }"
    (click)="onMenuItemClick(item)">
    <div class="link-content">
      @if (item.icon) {
      <i [class]="'bi bi-' + item.icon"></i>
      } @if (item.image) {
      <img
        [src]="'assets/images/icons/' + item.image"
        [alt]="item.name"
        class="menu-icon" />
      }
      <span class="menu-text">{{ item.name | translate }}</span>
      @if (item.count) {
      <span class="nav-count">{{ item.count }}</span>
      }
    </div>
  </a>
  } }

  <!-- Simple menu item without children - Collapsed mode -->
  @if (isCollapsed && level === MenuLevel.Root) { @if(item.isShown){
  <div class="collapsed-simple-item" [title]="item.name | translate">
    <a
      [routerLink]="item.url"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: false }"
      (click)="onMenuItemClick(item)"
      class="collapsed-simple-link">
      @if (item.icon) {
      <i [class]="'bi bi-' + item.icon"></i>
      } @if (item.image) {
      <img
        [src]="'assets/images/icons/' + item.image"
        [alt]="item.name"
        class="menu-icon" />
      }
    </a>
  </div>
  } }}

  <!-- Collapsed sidebar with hover dropdown -->
  @if (item.children && item.children.length > 0 && isCollapsed && level ===
  MenuLevel.Root) { @if(item.isShown){
  <div
    class="collapsed-menu-item"
    [class.active-parent]="isChildActive(item)"
    (mouseenter)="showHoverMenu(item, $event)"
    (mouseleave)="onMenuItemMouseLeave(item)">
    <div class="collapsed-trigger">
      @if (item.icon) {
      <i [class]="'bi bi-' + item.icon"></i>
      } @if (item.image) {
      <img
        [src]="'assets/images/icons/' + item.image"
        [alt]="item.name"
        class="menu-icon" />
      }
    </div>

    @if (item.hovered) {
    <div
      class="hover-dropdown"
      [ngClass]="currentLanguage === 'ar' ? 'rtl' : 'ltr'"
      [style.top.px]="item.dropdownTop"
      [style.left.px]="item.dropdownLeft"
      (mouseenter)="onDropdownMouseEnter(item)"
      (mouseleave)="onDropdownMouseLeave(item)">
      <div class="hover-header">{{ item.name | translate }}</div>
      <div class="hover-content">
        @for (child of item.children; track child.name) {
        <ng-container
          [ngTemplateOutlet]="hoverItemTemplate"
          [ngTemplateOutletContext]="{ item: child, level: MenuLevel.Level1 }">
        </ng-container>
        }
      </div>
    </div>
    }
  </div>
  } }

  <!-- Items with children inside hover dropdown (nested items) -->
  @if (item.children && item.children.length > 0 && isCollapsed && level >
  MenuLevel.Root) { @if(item.isShown){
  <div class="nested-menu-item">
    <div class="nested-header">{{ item.name | translate }}</div>
    <div class="nested-children">
      @for (child of item.children; track child.name) {
      <ng-container
        [ngTemplateOutlet]="menuItemTemplate"
        [ngTemplateOutletContext]="{ item: child, level: level + 1 }">
      </ng-container>
      }
    </div>
  </div>
  } }

  <!-- Expanded sidebar with mat-expansion-panel -->
  @if (item.children && item.children.length > 0 && !isCollapsed) {

  <mat-expansion-panel
    class="nav-expansion-panel"
    [class.active-parent]="isChildActive(item)"
    [class.nested-group]="level > MenuLevel.Root"
    [expanded]="item.expanded"
    (expandedChange)="onPanelToggle(item, $event)"
    hideToggle>
    <mat-expansion-panel-header
      class="nav-panel-header"
      [class.active-parent]="isChildActive(item)"
      (click)="onParentHeaderClick(item)">
      @if(item.isShown){
      <mat-panel-title
        class="nav-panel-title"
        [style.paddingInlineStart.px]="16 + level * 14">
        <div class="panel-header-content">
          @if (item.icon) {
          <i [class]="'bi bi-' + item.icon"></i>
          } @if (item.image) {
          <img
            [src]="'assets/images/icons/' + item.image"
            [alt]="item.name"
            class="menu-icon" />
          }
          <span class="menu-text">{{ item.name | translate }}</span>
        </div>

        <i
          class="expand-icon bi"
          [class.bi-chevron-right]="currentLanguage === 'en'"
          [class.bi-chevron-left]="currentLanguage === 'ar'">
        </i>
      </mat-panel-title>
      }
    </mat-expansion-panel-header>

    <div class="panel-content">
      @for (child of item.children; track child.name) {
      <ng-container
        [ngTemplateOutlet]="menuItemTemplate"
        [ngTemplateOutletContext]="{ item: child, level: level + 1 }">
      </ng-container>
      }
    </div>
  </mat-expansion-panel>
  }
</ng-template>

<!-- Hover Item Template for Dropdown -->
<ng-template #hoverItemTemplate let-item="item" let-level="level">
  <!-- Simple item without children -->
  @if (!item.children || item.children.length === 0) { @if(item.isShown){
  <a
    class="hover-menu-link"
    [class.level-1]="level === MenuLevel.Level1"
    [class.level-2]="level === MenuLevel.Level2"
    [class.level-3]="level === MenuLevel.Level3"
    [routerLink]="item.url"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: false }"
    (click)="onMenuItemClick(item)">
    <div class="hover-link-content">
      @if (item.icon) {
      <i [class]="'bi bi-' + item.icon"></i>
      } @if (item.image) {
      <img
        [src]="'assets/images/icons/' + item.image"
        [alt]="item.name"
        class="menu-icon" />
      }
      <span class="menu-text">{{ item.name | translate }}</span>
    </div>
  </a>
  } }

  <!-- Item with children (expandable) -->
  @if (item.children && item.children.length > 0) { @if(item.isShown){
  <div
    class="hover-expandable-item"
    [class.level-1]="level === MenuLevel.Level1"
    [class.level-2]="level === MenuLevel.Level2">
    <div
      class="hover-item-header"
      role="button"
      tabindex="0"
      (click)="onHoverParentClick(item)"
      (keydown.enter)="onHoverParentClick(item)"
      (keydown.space)="onHoverParentClick(item)">
      <div class="hover-header-content">
        @if (item.icon) {
        <i [class]="'bi bi-' + item.icon"></i>
        } @if (item.image) {
        <img
          [src]="'assets/images/icons/' + item.image"
          [alt]="item.name"
          class="menu-icon" />
        }
        <span class="menu-text">{{ item.name | translate }}</span>
      </div>
      <i
        class="expand-arrow bi"
        [class.bi-chevron-right]="!item.hoverExpanded"
        [class.bi-chevron-left]="item.hoverExpanded"></i>
    </div>

    @if (item.hoverExpanded) {
    <div class="hover-children">
      @for (child of item.children; track child.name) {
      <ng-container
        [ngTemplateOutlet]="hoverItemTemplate"
        [ngTemplateOutletContext]="{ item: child, level: level + 1 }">
      </ng-container>
      }
    </div>
    }
  </div>
  } }
</ng-template>
